import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { Container } from '@classes/container';

@Injectable({
  providedIn: 'root'
})
export class ContainersService {
    containersListChanged = new Subject<Container[]>();
    private baseUrl: string = environment.apiUrl + 'containers';
    private containers: Container[];

    constructor(
        private http: HttpClient
    ) { }

    getList(): Observable<Container[]> {
        return this.http.get<Container[]>(this.baseUrl)
        .pipe(
            map(containers => {
                this.containers = containers.map(c => Container.fromObject(c));
                this.containers.sort((a, b) => a.description.localeCompare(b.description));
                this.containersListChanged.next([ ...this.containers ]);
                return [ ...this.containers ];
            })
        );
    }

    put(container: Container): Observable<Container> {
        return this.http.put<Container>(this.baseUrl, container)
        .pipe(
            tap(editedContainer => {
                editedContainer = Container.fromObject(editedContainer);
                this.containers = this.containers.map(c => c.id === editedContainer.id ? editedContainer : c);
                this.containersListChanged.next([ ...this.containers ]);
            })
        );
    }

    post(container: Container): Observable<Container> {
        return this.http.post<Container>(this.baseUrl, container)
        .pipe(
            tap(createdContainer => {
                createdContainer = Container.fromObject(createdContainer);
                this.containers.push(createdContainer);
                this.containersListChanged.next([ ...this.containers ]);
            })
        );
    }

    delete(id: string): Observable<void> {
      return this.http.delete<void>(`${this.baseUrl}/${id}`)
      .pipe(
          tap(() => {
              this.containers = this.containers.filter(m => m.id !== id);
              this.containersListChanged.next([ ...this.containers ]);
          })
      );
  }
}
